// extracted by mini-css-extract-plugin
export default {"info":"feed-info_info__LuvGK"};